import { BaseComponent } from '@digibee/flow';

export const getTreeItemId = (
  item: BaseComponent | 'trigger' | 'starter-node'
) => (typeof item === 'string' ? item : item.id());
